import i18n from 'Portals/Supplier/utils/i18nService'

const generateDefaultMandatoryError = (entityName: string): string =>
	`${entityName} ${i18n.t('core:labels.cannotBeSaved')}. ${i18n.t(
		'core:constants.DEFAULT_MANDATORY_ERROR'
	)}:`

export const getRegistrationDocumentErrorMessage = () =>
	generateDefaultMandatoryError(i18n.t('pages:registrationDocument.document.title'))

export const getUploadInvoiceErrorMessage = () =>
	generateDefaultMandatoryError(i18n.t('pages:invoice.add.title'))

export const getUploadBackupDocumentErrorMessage = () =>
	generateDefaultMandatoryError(i18n.t('pages:invoice.edit.backupDocument.modal.title'))

export const getCancelInvoiceSuccessMessage = () =>
	i18n.t('pages:invoice.edit.cancelInvoice.successMessage')
export const getUploadInvoiceSuccessMessage = () => i18n.t('pages:invoice.add.successMessage')
export const getUploadBackupDocumentSuccessMessage = () =>
	i18n.t('pages:invoice.edit.backupDocument.modal.successMessage')

export const getRegistrationSumissionSuccessMessage = () =>
	i18n.t('pages:registrationDocument.message.successSubmit')

export const getRegistrationDocumentSaveSuccessMessage = () =>
	i18n.t('pages:registrationDocument.message.successSave')

export const getRegistrationDocumentSaveMessage = () => i18n.t('pages:document.saveMessage')
